import React, { Component } from "react";
import { View } from 'react-native'
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import SocketProvider from './utils/SocketProvider';
import SettingsProvider from './utils/SettingsProvider';
import BrowserNotification from "./components/BrowserNotification";
import styles from "./shared/styles";

import GetStarted from "./container/GetStarted";
import SignupSuccess from "./container/SignupSuccess";
import {
  SignIn,
  Welcome,
  CreateAccount,
  AccountSecurity,
  ConfirmDetails,
  JoinFamily,
  CreateTeam,
  Success
} from "./container/SharedContainer";

import OpenNativeapp from "./shared/containers/Other/OpenNativeapp";
import BookmarkContainer from "./shared/containers/Other/BookmarkContainer";
import ConnectionError from "./shared/containers/Other/ConnectionError";
import Pagenotfound from './shared/containers/Other/PageError404';

import HomeRoot from "./container/MainTabContainers/HomeRoot"
import ChatRoots from "./container/MainTabContainers/ChatRoots"
import ProfileRoots from "./container/MainTabContainers/ProfileRoots"
import invite from "./container/MainTabContainers/InviteRoot"
import SettingsRoots from "./container/MainTabContainers/SettingsRoots"

// import statistics from "./shared/containers/WE/root";
// import homework from "./shared/containers/Homework/root";

// import PasswordReset from "./shared/containers/profiles/ResetUserPassword";
// import Settings from './shared/containers/Other/Settings';
// import Nickname from './shared/containers/profiles/UpdateNickname';
// import UpdateEmail from './shared/containers/profiles/UpdateEmail';
// import UpdatePhone from './shared/containers/profiles/UpdatePhone';
// import AppLanguage from './shared/containers/Other/AppLanguage';

// import { global } from "./utils";

window.Base64Img = {};

class AppRoot extends Component {

  render() {
    const height = this.props.height;
    return (
      <SettingsProvider>
        <SocketProvider>
          <View style={styles.mobileContainer}>
            <View style={[styles.webview, { height }]}>
              <Switch>
                <Route exact path="/" component={GetStarted} />
                <Route exact path="/SignIn" component={SignIn} />
                <Route exact path="/Welcome" component={Welcome} />
                <Route exact path="/Create-Account" component={CreateAccount} />
                <Route exact path="/Account-Security" component={AccountSecurity} />
                <Route exact path="/confirm_details" component={ConfirmDetails} />
                <Route exact path="/Signup-Success" component={SignupSuccess} />
                <Route exact path="/Join-family" component={JoinFamily} />
                <Route exact path="/create-team" component={CreateTeam} />
                <Route exact path="/Join-family-success" component={Success} />
                <Route exact path="/open-native-app" component={OpenNativeapp} />
                <Route exact path="/Add-Bookmark" component={BookmarkContainer} />
                <Route exact path="/ConnectionError" component={ConnectionError} />
                <Route path="/dashboard" component={HomeRoot} />
                <Route path="/chat" component={ChatRoots} />
                <Route path="/profile" component={ProfileRoots} />
                <Route path="/invite" component={invite} />
                <Route path="/settings" component={SettingsRoots} />
                {/* <Route path="/statistics" component={statistics} />
                <Route path="/homework" component={homework} /> */}

                {/* <Route exact path="/settings" render={(props) => <Settings {...props} app={global.app_code} />} />
                <Route exact path="/settings/change-nickname" component={Nickname} />
                <Route exact path="/settings/change-email" component={UpdateEmail} />
                <Route exact path="/settings/change-phone" component={UpdatePhone} />
                <Route exact path="/settings/password-reset" component={PasswordReset} />
                <Route exact path="/settings/languages" component={AppLanguage} /> */}

                <Route render={Pagenotfound} />
              </Switch>
            </View>
            <BrowserNotification />
          </View>
        </SocketProvider>
      </SettingsProvider>
    )
  }
}

const mapStateToProps = ({ setting }) => {
  return {
    height: setting.height,
  };
};
export default connect(mapStateToProps)(AppRoot);